// extracted by mini-css-extract-plugin
export default {"tab":"style_tab__NULl6","values":"style_values__Jht+W","label":"style_label__9n0M5","tab_body":"style_tab_body__QKOJ3","tab_container":"style_tab_container__Jz7Oc"};